import type { InterviewEventReference } from '@core/interview-result-request-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const { actions, namespace, reducer, selectors } =
  createEntityCollectionStore<InterviewEventReference>()(
    'InterviewResultRequestInterviewEventReference',
    {
      customActions: adapter => ({
        references: (state, payload: { data: InterviewEventReference[] }) =>
          adapter.updateOrCreateMany(state, payload.data),
      }),
    },
  );

const InterviewEventReferenceActions = {
  references: actions.references,
};

export {
  InterviewEventReferenceActions,
  namespace as InterviewEventReferenceNamespace,
  reducer as InterviewEventReferenceReducer,
  selectors as InterviewEventReferenceSelectors,
};
